(function () {
	function fixIosDoubleTapIssue() {
		document.addEventListener(
			"touchend",
			function (e) {
				const target = e.target;
				const tag = target.tagName.toLowerCase();
				if (tag === "label") {
					e.preventDefault();
					target.click();
				} else if (tag === "span" && target.closest("label")) {
					e.preventDefault();
					target.closest("label").click();
				}
			},
			{ passive: false }
		);
	}
	document.addEventListener("DOMContentLoaded", fixIosDoubleTapIssue);
})();
